module.exports = __webpack_public_path__ + "img/horizontal_2_1_6000.a3474b01.png";